module.exports = __webpack_public_path__ + "static/media/fte-breathe-thumbnail.1499780a.png";